module.exports = __webpack_public_path__ + "static/img/project_kcjy.b643692c.png";